// Cookies
$('#accept-cookies').click(function(e){
    e.preventDefault();
    createCookie("accept_cookies", true, 365);
    $('#accept-cookies-form').hide();
});

function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}